import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css/pagination';

import {
    GenerativeAISolCurrency,
    GenerativeAISolCadiology,
    GenerativeAISolHeadset,
    GenerativeAISolReaLState,
    GenerativeAISolEducation,
    GenerativeAISolIt,
    GenerativeAISolController,
    GenerativeAISolCart,
} from "../../../app-constants";

function generativeAiSolutions() {

  
  return (
    
    <section className="generative_ai_partner generative_ai_solutions p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              We Build Diverse <span>Gen AI Solutions</span>
            </h2>
          </Col>
        </Row>
       

          <div className='gen-sol-wrap mt-3 mt-md-4'>
            <Swiper
                modules={[Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                pagination={{ clickable: true }}
                onSwiper={() => console.log('slide change')}
                onSlideChange={() => console.log('slide change')}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                  },
                  575: {
                    slidesPerView: 1.5,
                  },
                  666: {
                    slidesPerView: 1.5,
                  },
                  768: {
                    slidesPerView: 1.8,
                  },
                  992: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                  1400: {
                    slidesPerView: 3.7,
                  },
                }}
                className="gen-sol-slider"
                >
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolCadiology}</div>
                    <div className="generative_ai_content">
                      <h5>Healthcare</h5>
                      <p>Streamline medical diagnostics, personalized treatment planning, and patient data management through custom generative AI applications.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolCurrency}</div>
                    <div className="generative_ai_content">
                      <h5>Fintech</h5>
                      <p>Enhance fraud detection, risk assessment, and customer service automation with AI-driven financial solutions.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolHeadset}</div>
                    <div className="generative_ai_content">
                      <h5>
                        Customer Care
                      </h5>
                      <p>Boost operational efficiency, predictive analysis, and customer satisfaction by integrating AI into support workflows.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolReaLState}</div>
                    <div className="generative_ai_content">
                      <h5>
                        Real Estate
                      </h5>
                      <p>Automate property valuation, enhance virtual tours, and streamline property management with AI-driven innovations.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolCart}</div>
                    <div className="generative_ai_content">
                      <h5>
                        eCommerce
                      </h5>
                      <p>Optimize inventory, pricing strategies, and customer personalization using predictive AI algorithms.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolEducation}</div>
                    <div className="generative_ai_content">
                      <h5>
                        Education
                      </h5>
                      <p>Boost operational efficiency, predictive analysis, and customer satisfaction by integrating AI into support workflows.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolIt}</div>
                    <div className="generative_ai_content">
                      <h5>
                        IT
                      </h5>
                      <p>Accelerate software development, system optimization, and cybersecurity with generative AI technologies.</p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="generative_ai_box">
                    <div className="generative_ai_svg">{GenerativeAISolController}</div>
                    <div className="generative_ai_content">
                      <h5>
                        Gaming
                      </h5>
                      <p>Create immersive, adaptive gaming experiences with AI-driven content generation and player behavior analysis.</p>
                    </div>
                  </div>
                </SwiperSlide>
            </Swiper>
          </div>
      
      </Container>
    </section>

  )
}

export default generativeAiSolutions